import { paths } from '@/lib/routes/site-paths'
import { languages, normalizeLocale, type AppLocale } from '@/lib/i18n/settings'
import { pathWithLocale } from '@/lib/i18n/locale-path'

export function getHomeRoutes(locale: string) {
  const l = normalizeLocale(locale)
  const p = (path: string) => pathWithLocale(locale, path)

  const localeHomes = Object.fromEntries(
    languages.map((code) => [code, `/${code}`]),
  ) as Record<AppLocale, string>

  return {
    locale: l,
    localeHome: `/${l}`,
    platform: p(paths.platform),
    products: p(paths.products),
    productsPos: p(paths.productsPosCustomerExperience),
    productsIntegrationHub: p(paths.productsIntegrationHub),
    solutions: p(paths.solutions),
    solutionsCoffeeQsr: p(paths.solutionsCoffeeChainQsr),
    solutionsMultiBrand: p(paths.solutionsMultiBrand),
    solutionsFranchising: p(paths.solutionsFranchising),
    solutionsMultinationalFb: p(paths.solutionsMultinationalFb),
    solutionsChainReadyIndependent: p(paths.solutionsChainReadyIndependent),
    customers: p(paths.customers),
    insights: p(paths.insights),
    insightsWhitepapers: p(paths.insightsWhitepapers),
    insightsPerspectives: p(paths.insightsPerspectives),
    insightsCaseStudies: p(paths.insightsCaseStudies),
    insightsEngineering: p(paths.insightsEngineering),
    insightsTechnologySolutions: p(paths.insightsTechnologySolutions),
    partners: p(paths.partners),
    company: p(paths.company),
    contact: p(paths.contact),
    inventoryLogistic: p(paths.productsInventoryLogistic),
    careers: p(paths.companyCareers),
    systemStatus: p(paths.systemStatus),
    privacy: p(paths.privacy),
    terms: p(paths.terms),
    contactBriefing: p(paths.contact),
    contactSolution: p(paths.contact),
    contactArch: p(paths.contact),
    posProduct: p(paths.productsPosCustomerExperience),
    localeHomes,
  }
}

export type HomeRoutes = ReturnType<typeof getHomeRoutes>
